import { isEqual, isNil } from "lodash";
// import { connect } from "react-redux";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";

import ErrorBoundary from "../../../components/errorBoundary";
import FormButton from "../../../components/form/FormButton";
import ModalFooter from "../../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../../components/modal/ModalFooterRightGroup";
import ModalHeading from "../../../components/modal/ModalHeading";
import ModalTabView from "../../../components/modal/ModalTabView";
// import { uiStateOperations } from "../../modules/uiState";
import ModalView from "../../../components/modal/ModalView";
import PubSubTopics from "../../../constants/pubSubTopics";
import Dimensions from "../../../constants/styles/dimensions";
import dialogs from "../../../dialogs";
import definitionReducer, { definitionSelectors } from "../../../modules/definition";
import preprocessorQuery from "../../../utils/preprocessorQuery";
import selectors from "../selectors";
import SettingsPropertiesTab from "./SettingsPropertiesTab";
import SettingsReferencesTab from "./SettingsReferencesTab";
import SettingsTypesTab from "./SettingsTypesTab";

class AdvancedSettingsModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      //#!if iOS !== true
      localStore: null,
      //#!endif
      activeTab: !isNil(this.props.activeTab) ? this.props.activeTab : 0
    };

    this.dispatchLocal = this.dispatchLocal.bind(this);
    this.onDoneClick = this.onDoneClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
  }

  componentWillMount() {
    this.copyLocalStore(this.props);
  }

  componentDidMount() {
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  copyLocalStore(props) {
    //#!if iOS !== true
    this.setState({
      localStore: props.localStore
    });
    //#!endif
  }

  dispatchLocal(a) {
    //#!if iOS === true
// this.props.dispatchLocal(a);
    //#!else
    const newStore = this.state.localStore.set(
      "definitions",
      definitionReducer(this.state.localStore.definitions, a, this.state.localStore)
    );
    this.setState({ localStore: newStore });
    //#!endif
  }

  onDoneClick() {
    //#!if iOS === true
// this.props.onDoneClick();
    //#!else
    this.props.onDoneClick(this.state.localStore);
    //#!endif
  }

  onCloseClick() {
    //#!if iOS === true
// this.props.onCloseClick();
    //#!else
    if (
      this.state.localStore !== this.props.localStore &&
      !isEqual(this.state.localStore.toJS(), this.props.localStore.toJS())
    ) {
      const msg = "Are you sure you want to close without applying your Advanced Settings changes?";
      dialogs.okCancelPrompt(msg, result => {
        if (result) {
          this.props.onCloseClick();
        }
      });
    } else {
      this.props.onCloseClick();
    }
    //#!endif
  }

  onTabClick(index) {
    const isIos = preprocessorQuery.isIos();
    if (isIos && isNil(index)) {
      this.onCloseClick();
    } else {
      this.setState({
        activeTab: index
      });
    }
  }

  tabViews() {
    let localStore = null;
    //#!if iOS === true
// localStore = this.props.localStore;
    //#!else
    localStore = this.state.localStore;
    //#!endif

    return [
      {
        icon: "settingsItemTypes",
        label: "Item Types",
        view: (
          <SettingsTypesTab
            types={selectors.getTypes(localStore)}
            properties={localStore.definitions.properties}
            references={localStore.definitions.references}
            dispatchLocal={this.dispatchLocal}
            colorOptions={definitionSelectors.getColorOptions(localStore)}
            timelineViewSettings={definitionSelectors.getTimelineViewSettings(localStore)}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
// doneDisabled={!this.props.isValid}
// footer={this.renderModalFooter()}
            //#!endif
          />
        )
      },
      {
        icon: "settingsRelationships",
        label: "Relationships",
        view: (
          <SettingsReferencesTab
            references={localStore.definitions.references}
            types={localStore.definitions.types}
            dispatchLocal={this.dispatchLocal}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
            //#!endif
          />
        )
      },
      {
        icon: "settingsTypes",
        label: "Properties",
        view: (
          <SettingsPropertiesTab
            properties={localStore.definitions.properties}
            types={localStore.definitions.types}
            dispatchLocal={this.dispatchLocal}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
            //#!endif
          />
        )
      }
    ];
  }

  renderModalFooter() {
    let modalFooter = null;
    // #!if iOS === true
// if (!this.props.isValid) {
// modalFooter = (
// <ModalFooter>
// <div className="warning">Invalid settings must be corrected before saving.</div>
// </ModalFooter>
// );
// }
    // #!else
    modalFooter = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={true} label="OK" onClick={this.onDoneClick} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
    // #!endif
    return modalFooter;
  }

  render() {
    let localStore = null;
    //#!if iOS === true
// localStore = this.props.localStore;
    //#!else
    localStore = this.state.localStore;
    //#!endif

    let modalHeading = null;
    const modalFooter = this.renderModalFooter();
    const fixedHeight = Dimensions.MODAL_MAX_HEIGHT;

    // #!if iOS === true
// modalHeading = (
// <ModalHeading
// title="Advanced Settings"
// showBack={true}
// onBackClick={this.onCloseClick}
// showDone={true}
// onDoneClick={this.onDoneClick}
// />
// );
    // #!else
    modalHeading = <ModalHeading title="Advanced Settings" showCancel={true} onCancelClick={this.onCloseClick} />;
    // #!endif

    return (
      <ModalView header={modalHeading} footer={modalFooter} fixedHeight={fixedHeight}>
        <ErrorBoundary store={localStore}>
          <ModalTabView
            activeTab={this.state.activeTab}
            tabs={this.tabViews()}
            onTabClick={this.onTabClick}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
// doneDisabled={!this.props.isValid}
// footer={modalFooter}
            //#!endif
          />
        </ErrorBoundary>
      </ModalView>
    );
  }
}

AdvancedSettingsModal.propTypes = {
  activeTab: PropTypes.number,
  localStore: PropTypes.object.isRequired,
  //#!if iOS === true
// dispatchLocal: PropTypes.func.isRequired,
  //#!endif
  onDoneClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  fontSize: PropTypes.number.isRequired,
  isValid: PropTypes.bool,
  validationError: PropTypes.string
};

export default AdvancedSettingsModal;
